.me-logo {
  display: inline-flex;

  img {
    display: block;
    width: 100%;
    max-height: 36px;

    @include desktop {
      max-height: 40px;
    }
  }

  &--text {
    font-weight: bold;
    text-decoration: none;
  }
}
